// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2FLm3","balanceDisclaimer":"posDashboard_balanceDisclaimer__2Ouzz"};